(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { TextField as MuiTextField, InputAdornment } from '@material-ui/core';
import { Icon } from "../icons";
import { COLOR } from "../../constants/style"; // eslint-disable-next-line

var TextField = forwardRef(function (props, ref) {
  var label = props.label,
      autoFocus = props.autoFocus,
      icon = props.icon,
      name = props.name,
      value = props.value,
      fullWidth = props.fullWidth,
      onChange = props.onChange,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      testSelector = props.testSelector,
      rest = _objectWithoutProperties(props, ["label", "autoFocus", "icon", "name", "value", "fullWidth", "onChange", "inputProps", "InputProps", "testSelector"]);

  var inputRef = ref ? {
    inputRef: ref
  } : {};
  return React.createElement(MuiTextField, _extends({}, rest, inputRef, {
    value: value,
    onChange: onChange,
    name: name,
    variant: "outlined",
    label: label,
    fullWidth: fullWidth,
    autoFocus: autoFocus,
    inputProps: _objectSpread({}, inputProps, {
      'data-test-selector': testSelector || name
    }),
    InputProps: _objectSpread({}, InputProps, {
      startAdornment: icon ? React.createElement(InputAdornment, {
        position: "start"
      }, React.createElement(Icon, {
        name: icon,
        color: COLOR.gray.darker
      })) : null
    })
  }));
});
TextField.defaultProps = {
  autoFocus: false
};
TextField.propTypes = {
  variant: PropTypes.oneOf(['notched'])
};
var _default = TextField;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TextField, "TextField", "/home/vsts/work/1/s/src/components/inputs/TextField.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/inputs/TextField.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();